import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {SUMM_GRADUATES_HEO_REQUEST} from "../summGraduatesHEOReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${SUMM_GRADUATES_HEO_REQUEST}${START}`:
            return true;
        case `${SUMM_GRADUATES_HEO_REQUEST}${SUCCESS}`:
            return false;
        case `${SUMM_GRADUATES_HEO_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};